import * as React from 'react'
import styled from 'styled-components'

import { FbEnrichedUser } from '../../../interfaces/User'
import { Identigradient } from '../../global'

// ========================== React component ==================================

const ImageContainer = styled.img<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  z-index: 2;
`

interface Props {
  size: number
  item?: FbEnrichedUser
}

const ProfileImage = ({ item, size }: Props): JSX.Element | null => {
  if (!item) {
    return null
  }

  const { address, profileImageUri } = item
  return profileImageUri ? (
    <ImageContainer
      src={
        'https://glassimg.imgix.net/' +
        profileImageUri +
        `?w=${size * 2}&h=${size * 2}&fit=crop&crop=faces,center&fm=webp`
      }
      size={size}
    />
  ) : (
    <Identigradient seed={address} radius={size} />
  )
}

export default ProfileImage
